const state = {
  charts: {}
}

const modules = {}

const getters = {
  charts: state => state.charts,
  getChartTooltip: (state) => (id) => {
    return state.charts[id]?.tooltip
  }
}

const mutations = {
  addChart: (state, [chartName, value]) => {
    state.charts[chartName] = value || {}
  },
  removeChart: (state, [chartName]) => {
    delete state.charts[chartName]
  },
  setTooltip: (state, [chartName, details]) => {
    state.charts[chartName] = details
  }
}

const actions = {
  addChart({ commit }, [chartName, value]) {
    commit('addChart', [chartName, value])
  },
  removeChart({ commit }, chartName) {
    commit('removeChart', [chartName])
  },
  setTooltip({ commit }, [chartName, details]) {
    commit('setTooltip', [chartName, details])
  }
}

const namespaced = true

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
  modules
}
